module.exports = __webpack_public_path__ + "static/media/cw-logo-new.6da11145.png";